import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileUtils from '../../../../utils/file/file-utils';
import { ContactUsComponent } from '../contact-us/contact-us.component';

@Component({
    selector: 'ca-supported-formats-dialog',
    templateUrl: './supported-formats-dialog.component.html',
    styleUrls: ['./supported-formats-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportedFormatsDialogComponent {
    //supported file formats
    recommendedFileTypes: string[] = ['.czi'];
    otherFileTypes: string = ['.jpeg', '.jpg', '.png', '.ome.tif', '.ome.tiff'].join(', ');

    potentiallyUploadableFileTypes = [...FileUtils.machineLearningSupportedFileTypes]
        .filter(item => !this.recommendedFileTypes.concat(this.otherFileTypes.split(', ')).includes(item))
        .sort((a, b) => a.localeCompare(b))
        .join(', ');

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private modalService: NgbModal,
    ) {}

    openContactUs(): void {
        this.modalService.open(ContactUsComponent, { size: 'lg' });
    }

    dismiss(): void {
        this.ngbActiveModal.dismiss();
    }
}
